import React from 'react';
import UserApp from './user/UserApp';
import './index.css';
import Demo from './Demo';

function App() {
  return <UserApp />;
}

export default App;
